import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerModule,
} from "@angular/platform-browser";
// import { GestureConfig, MatDialogModule, MatGridListModule, MatSnackBarModule, MatTooltipModule } from "@angular/material";
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';  // Importing MatDialogModule
import { MatGridListModule } from '@angular/material/grid-list';  // Importing MatGridListModule
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';  // Importing MatSnackBarModule
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';  // Importing MatTooltipModule
// import { GestureConfig } from '@angular/material/core';  // For GestureConfig if you need it

import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './router-strategy';

// import {
//   MatInputModule,
//   MatButtonModule,
//   MatSelectModule,
// } from "@angular/material";

import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";

import { MatIconModule } from "@angular/material/icon";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { FormsModule } from "@angular/forms";
import { HomeComponent } from "./components/home/home.component";
import { PagenotfoundComponent } from "./components/pagenotfound/pagenotfound.component";
import { ForbiddenComponent } from "./components/forbidden/forbidden.component";
import { ScrollTopService } from "./services/scroll-top.service";
import { WebsiteComponent } from "./components/website/website/website.component";
import { DatePipe } from "@angular/common";
// import { ChatscrollDirective } from './common/directive/chatscroll.directive';
import { BaseModule } from "./modules/base/base.module";
import { UploadErrorComponent } from "./components/common/upload-error/upload-error.component";
import { AppPublisherComponent } from "./app-publisher/app-publisher.component";
import { AppSubscriberComponent } from "./app-subscriber/app-subscriber.component";
import { VideoCallComponent } from './video-call/video-call.component';
import { RejoinCallComponent } from './rejoin-call/rejoin-call.component';
import { ActiveUsersComponent } from "./modules/chat/active-users/active-users.component";
import { GlobalPopupComponent } from './global-popup/global-popup.component';
import { DeepLinkComponent } from './components/deep-link/deep-link.component';
import { EmailNotFoundComponent } from './components/common/email-not-found/email-not-found.component';
import { UnderMaintenanceComponent } from './components/under-maintenance/under-maintenance.component';
import { NoPermissionComponent } from './components/common/no-permission/no-permission.component';
import { NoActiveUsersComponent } from './components/common/no-active-users/no-active-users.component';
import { ConvertComponent } from './components/common/convert/convert.component';
import { MessagesModule } from 'primeng/messages';
import { SlackComponent } from './components/common/slack/slack.component';
import { ListComponent } from './components/vision2025/list/list.component';
import { GlobalLoaderComponent } from './components/loader/global-loader.component';

import { StoreModule } from '@ngrx/store';
import { ArticleReducer } from './reducers/shops.reducer';
import { ImportReducer } from "./reducers/import.reducer";
import { ToolsReducer } from "./reducers/tools.reducer";

import { CheckboxModule } from "primeng/checkbox";
import { MenuModule } from 'primeng/menu';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ColorPickerModule } from 'primeng/colorpicker';
import { AccordionModule } from 'primeng/accordion';
import { PaypalComponent } from './components/paypal/paypal.component';
import { S3UploadComponent } from './components/s3-upload/s3-upload.component';
// import { TrainingCalendarComponent } from './components/service-market-place/training-calendar/training-calendar.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PagenotfoundComponent,
    ForbiddenComponent,
    WebsiteComponent,
    UploadErrorComponent,
    DeepLinkComponent,
    EmailNotFoundComponent,
    AppPublisherComponent,
    AppSubscriberComponent,
    VideoCallComponent,
    RejoinCallComponent,
    GlobalPopupComponent,
    DeepLinkComponent,
    UnderMaintenanceComponent,
    NoPermissionComponent,
    NoActiveUsersComponent,
    ConvertComponent,
    SlackComponent,
    ListComponent,
    GlobalLoaderComponent,
    PaypalComponent,
    S3UploadComponent,
    // TrainingCalendarComponent,
    //ChatscrollDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    BaseModule,
    HammerModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatMomentDateModule,
    MatDatepickerModule,
    MatGridListModule,
    MatSnackBarModule,
    MatTooltipModule,
    MessagesModule,
    CheckboxModule,
    InputSwitchModule,
    ColorPickerModule,
    AccordionModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: '4e835741-d75c-4fbe-bf8a-13f6a7788ddd',
        postLogoutRedirectUri: 'https://collabtic.fieldpulse.co/auth/integration'
      }
    }), null, null),
    StoreModule.forRoot({
      equipment: ArticleReducer,
      importing: ImportReducer,
      tools: ToolsReducer
    }),
  ],
  providers: [
    // { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    MatMomentDateModule,
    MatDatepickerModule,
    MatDialogModule,
    ScrollTopService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
  entryComponents: [ActiveUsersComponent]
})
export class AppModule { }
